export default __webpack_public_path__ + "static/media/avatar1.23442d4a.png";